import React from 'react';
import Link from 'next/link'
import {Container, Typography} from "@mui/material";
import colorPalette from "../../../../styles/theme/colorPalette";
import LinkButton from "../../../atoms/LinkButton";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import {css} from "@emotion/react";
import TelSpSvg from '../../../../../public/images/shop/top/tel-sp.svg'
import TelSvg from '../../../../../public/images/shop/top/tel.svg'
import OtameshiSvg from '../../../../../public/images/shop/top/otameshi.svg'
import SignUp from '../../../../../public/images/shop/top/signup.svg'
import { isMobile } from "react-device-detect";

const Support = () => {
  return (
      <Container>
        <div css={{padding:'32px'}}>
          <div css={{textAlign: 'center',fontSize: '2rem', fontWeight: 500}}>ミールタイムは</div>
          <Typography variant={'h1'} css={{fontWeight: 'bold', padding: '8px'}}>「栄養士がサポートする安心な食事」</Typography>
          <div css={{textAlign: 'center',fontSize: '2rem', fontWeight: 500}}>を提供しています</div>
        </div>
        <div>
          <div css={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <OtameshiSvg css={{
              maxWidth: '460px',
              width: '100%',
              margin: '32px'
            }}/>
            <Link href={'/signup'}>
              <a css={{width: '100%', textAlign: 'center'}}>
                <SignUp css={{
                  maxWidth: '460px',
                  width: '100%',
                  cursor: 'pointer'
                }}/>
              </a>
            </Link>
            {
              isMobile &&
              <TelSpSvg css={{
                maxWidth: '380px',
                width: '100%',
                margin: '48px'
              }}/>
                ||
              <TelSvg css={{
                maxWidth: '380px',
                width: '100%',
                margin: '48px'
              }}/>
            }
          </div>
        </div>
        <div css={btnWrapper}>
          <LinkButton
              text={'商品一覧を見る'}
              href={'/sign_up'}
              maxWidth={"300px"}
              hexColorCode={colorPalette.gray}
              endAdornment={ <ArrowRightIcon /> }
              css={btnStyle}
          />
        </div>
        <div css={[btnWrapper,{marginBottom: '32px'}]}>
          <LinkButton
              text={'カタログを見る'}
              href={'/catalog/view'}
              maxWidth={"300px"}
              hexColorCode={colorPalette.gray}
              endAdornment={ <ArrowRightIcon /> }
              css={btnStyle}
          />
        </div>
      </Container>
  );
};

export default Support;

const btnWrapper = css`
  display: flex;
  justify-content: center;
  margin: 24px 0;
`

const btnStyle = css`
`